import { CURRENT_AGENT_AGREEMENT_VERSION } from "./fees.js";

export const AGENT_AGREEMENT_PAPERWORK_TITLE =
  "Independent Contractor Agreement";

/**
 * Fillable PDF for signing (pdf-lib). Upload the converted PDF to S3 bucket root.
 * DOCX alone cannot be used for electronic signing in the app.
 *
 * S3 upload checklist:
 * 1. Export the Word contract as PDF (File → Save As → PDF).
 * 2. Upload to bucket `brokeragentbase` (root — same as the old Standard ICA).
 * 3. Object key: `In Depth Realty Updated Contract Septermber 1st 2026.pdf`
 * 4. Set object ACL to public-read.
 */
export const AGENT_AGREEMENT_PDF_URL =
  "https://brokeragentbase.s3.amazonaws.com/In%20Depth%20Realty%20Updated%20Contract%20Septermber%201st%202026.pdf";

export const AGENT_AGREEMENT_S3_UPLOAD_HELP =
  "Export the contract as a PDF, then upload it to the brokeragentbase S3 bucket root as In Depth Realty Updated Contract Septermber 1st 2026.pdf with public-read access. Word (.docx) files cannot be signed in the app.";

/** Preview iframe URL (same as PDF once uploaded). */
export const AGENT_AGREEMENT_PREVIEW_URL = AGENT_AGREEMENT_PDF_URL;

export const AGENT_AGREEMENT_BROKER_NAME = "Shawn Kenney";

export const AGENT_AGREEMENT_SALESPERSON_FIELD = "Text-2";

export const AGENT_AGREEMENT_DATE_FIELD_NAMES = [
  "Datefor",
  "Date-UmhjyFVm7Q",
  "Date-lp3s08IqyR",
  "Date-5dlZMJ-k_d",
  "Date-Q6eWflRnYZ",
  "Date-tYyCyajztN",
  "Date-01d1MUEWmf",
  "Date-kjDfYznWpK",
  "Date-0zMlYqw7RC",
  "Date-hZnp26AmC_",
  "Date-UXrRVROjjE",
  "Date-mIUd5vU4wQ",
  "Date-flNoUatAs_",
  "Date-Q1KWIkEd3j",
  "Text-1",
];

export const AGENT_AGREEMENT_AUTO_AGENT_NAME_FIELDS = ["Text-FtWzrAoEX5"];

export const AGENT_AGREEMENT_AUTO_BROKER_NAME_FIELDS = [
  "Text-UhBRgC5wDw",
  "Text-yGXRq14uJW",
];

export const AGENT_AGREEMENT_SIGNATURE_PLACEMENT = {
  secondaryPageIndex: 1,
  secondarySignature: { x: 100, y: 550, width: 100, height: 50 },
  finalSignature: { x: 100, y: 550, width: 100, height: 50 },
  initialsOnEveryPage: { x: 400, y: 115, width: 200, height: 100 },
};

export { CURRENT_AGENT_AGREEMENT_VERSION };
